<template>
  <div class="app-home-container">
    <!-- <div class="app-header app-linear-bg" style="height: auto;" v-if="this.$store.getters.getBaseInfo.ico">
      <img
                class=""
                style="height: 50px;padding: 0 15px;display: block;"
                :src="
                  this.$store.getters.getBaseInfo.ico"
              />
              <div style="flex: 1;"></div>
              <van-icon name="service-o" size="24" color="#fff" style="margin-right: 10px;" v-if="iskefu == '1'" @click="toKefu" />
    </div> -->

    <van-nav-bar class="app-nav-bar app-nav-bar-transparent">
      <!-- <template #left>
        <span class="home-page__app-name">

          {{ $store.getters.getBaseInfo.name }}
        </span>
      </template> -->

      <template #right>
        <span class="home-page__app-name" @click="addr_popup = true"><van-icon name="location-o" size="20" color="#ffffff" />{{
          $t("nHome.checked_address")
          }}</span>
      </template>
    </van-nav-bar>

    <div class="app-mask" v-if="isLoading && video_login == 1 && !token">
      <van-loading type="spinner" size="80px" />
    </div>
    <div class="app-linear-bg"></div>
    <div class="home-page__home-scroll">
      <div class="home-page__banner">
        <swiper class="home-page__banner-carousel" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="home-page__banner-image" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>
      <div class="home-page__notice-content">
        <div class="home-page__introduction">
          <div>
            <div class="app-left">
              <p>
                {{ $t('zise.meiti') }}
              </p>

              <p>
                
                {{ $t("zise.home_txt1") }}
              </p>

              <p>
                
                {{ $t("zise.home_txt2") }}
              </p>
              <p>
                
                {{ $t("zise.home_txt3") }}
              </p>
              <!-- <span>
                {{ $t('zise.fuli') }}
              </span> -->
            </div>
            <div class="app-right">
              <p>
                {{ $t('zise.ziyuan') }}
              </p>
            </div>
          </div><span>
            {{ $t('zise.jiaru') }}

          </span>
        </div>
      </div>
     
      <div class="home-page__hot-game">
        <div class="home-page__featured-header">
          <div>

            <span>{{$t('index.recmonmand')}}</span>
          </div>
        </div>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')"
        :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
        <van-list class="home-page__featured-profiles" v-model="loading" :finished="finished" :offset="50" :immediate-check="false"
          :finished-text="$t('video.no_more')" @load="onLoad" :loading-text="$t('refresh.loading')">
          <div class="home-page__featured-items" v-if="movielist_1.length > 0">
            <ul>
              <li v-for="(v, key) in movielist_1" :key="key" @click="toPlayVideo(v.id)"><img
                  :src="v.img_url">
                <ul>
                  <li>
                    <div><img style="width: 10px;" src="@/assets/images/shared/vip.png" alt="">{{ $t('xuanfei.Authentication') }}</div>
                    <div><img style="width: 10px;" src="@/assets/images/shared/vip.png" alt="">{{ $t('xuanfei.VideoAuthentication') }}</div> 
                    <!-- <div>{{v.xuanfei_name}}</div> -->
                  </li>
                  <li>
                    <div v-for="(li,indexs) in v.service_data" :key="indexs">{{li}}</div>
                  </li>
                  <li><span>{{$t('xuanfei.ChargingRange')}}:</span>
                    <!-- <span class="app-movie-list-money">{{ v.price }}</span> -->
                    <van-rate
                    :value="5"
                    :size="20"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                  />
                  </li>
                  <li><span>{{$t('xuanfei.height')}}:{{v.height}}{{$t('xuanfei.round1')}}: {{v.one}} <br/>
                     {{$t('xuanfei.serveCity')}}:{{v.address}}</span></li>
                  <li>{{$t('xuanfei.DateHer')}} </li>
                </ul>
              </li>
            </ul>
          </div>
        </van-list>

      </van-pull-refresh>
    </div>
    <van-popup v-model="pop_content" round closeable close-icon="close"
      style="width:70%;height: 50%;font-size: 24px;">
      <div class="home-page__popup-content" v-html="pop_content_txt"></div>


    </van-popup>

    <van-popup v-model="addr_popup" round close-icon="close"
      style="width:70%;background: none;">
      <ul class="home-page__city-picker">
        <template v-if="viodeLang == 'ja_ja'">
          <li><i class="cubeic-like"></i> 東京です</li>
          <li @click="openAddr">大阪です</li>
          <li @click="openAddr">神奈川県です</li>
          <li @click="openAddr">京都です</li>
          <li @click="openAddr">沖縄です</li>
          <li @click="openAddr">福岡県です</li>
          <li @click="openAddr">北海道です</li>
          <li @click="openAddr">横浜です</li>
        </template>
        <template v-else>
          <li><i class="cubeic-like"></i> 인기 지역</li>
          <li @click="openAddr">서울</li>
          <li @click="openAddr">부산</li>
          <li @click="openAddr">인천</li>
          <li @click="openAddr">대구</li>
          <li @click="openAddr">대전</li>
          <li @click="openAddr">광주</li>
          <li @click="openAddr">경주</li>
          <li @click="openAddr">울산</li>
          <li @click="openAddr">창원</li>
          <li @click="openAddr">세종특별자치시</li>

          <li @click="openAddr">제주도</li>
          
          
          <li @click="openAddr">경기도</li>
          <li @click="openAddr">강원도</li>
          <li @click="openAddr">충청북도</li>
          <li @click="openAddr">충청남도</li>
          <li @click="openAddr">전라북도</li>
          <li @click="openAddr">전라남도</li>
          <li @click="openAddr">경상북도</li>
          <li @click="openAddr">경상남도</li>
          
          <li @click="openAddr"><span> 더 보기 </span></li>
        </template>
      </ul>


    </van-popup>

    <img class="app-luck-draw" v-if="isluckdraw == '1'" @click="toLuckDraw" src="@/assets/images/shared/luckdraw.png" alt="">
    <img class="home-page__kefu" v-if="iskefu == '1'" src="@/assets/images/shared/kefu.png" @click="toKefu" alt="" srcset="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      banners: [{}],
      basicData: [],
      gameitem: [{}, {}, {}, {}],
      movielist_0: [{}, {}, {}, {}],
      movielist_1: [],
      loading: false,
      finished: false,
      isLoading: true,
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      video_login: this.$store.getters.getBaseInfo.video_login || 1,
      token: localStorage.getItem('token'),
      isluckdraw: null,
      pop_content_txt: '',
      pop_content: false,
      kefu: '',
      iskefu: 0,

      coordinate: {
        client: {},
        elePosition: {}
      },
      page: 1,
      tabs: 0,
      addr_popup: false,
      viodeLang:localStorage.getItem("viodeLang")|| ''

    };
  },
  methods: {
    openAddr() {
      if(this.viodeLang == 'ja_ja'){

        this.$toast.loading({
        message: ' 管理者に連絡してアカウントを有効にします',
        forbidClick: true,
      });
      }else{
        
      this.$toast.loading({
        message: ' 관리자에게 연락하여 계정을 활성화하십시오',
        forbidClick: true,
      });
      }
      this.addr_popup = false
    },
    getxuanfeilist() {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.datalist = res.data;
      });
    },
    toKefu() {

      window.location.href = this.kefu
    },
    touchStartHandle(refName, e) {
      let element = e.targetTouches[0]
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY
      }
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop
    },
    drag(refName, e) {
      let element = e.targetTouches[0]
      // 根据初始client位置计算移动距离（元素移动位置+光标移动后的位置-光标点击时的初始位置）
      let x = this.coordinate.elePosition.left + (element.clientX - this.coordinate.client.x)
      let y = this.coordinate.elePosition.top + (element.clientY - this.coordinate.client.y)
      // 限制可移动距离，不超出可视区域
      x = x <= 0 ? 0 : x >= innerWidth - this.$refs[refName].offsetWidth ? innerWidth - this.$refs[refName].offsetWidth : x
      // 50是头部的高度
      y = y <= 50 ? 50 : x >= innerHeight - this.$refs[refName].offsetHeight ? innerHeight - this.$refs[refName].offsetHeight : y
      // 移动当前元素
      this.$refs[refName].style.left = x + 'px'
      this.$refs[refName].style.top = y + 'px'
    },
    toLuckDraw() {
      this.$router.push({ path: '/games/lucky-draw' })
    },
    gotoMenu(router) {
      this.$router.replace(router)
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token') && this.$store.getters.getBaseInfo.video_login == 1) {
        this.$router.push({ path: '/auth/login' })
      } else {
        if (id) {
          this.$router.push({ path: '/games/lottery?key=' + key + "&id=" + id })
        }
      }

    },
    // toPlayVideo(id) {

    //   if(!localStorage.getItem('token') && this.$store.getters.getBaseInfo.video_login == 1){
    //     this.$router.push({path:'/auth/login'})
    //   } else {
    //     if (id) {
    //      this.$router.push({path:'/videos/play?id='+id})
    //     }
    //   }
    // },

    toPlayVideo(id) {

      if (!localStorage.getItem('token') && this.$store.getters.getBaseInfo.video_login == 1) {
        this.$router.push({ path: '/auth/login' })
      } else {
        if (id) {
          this.$router.push({ path: '/discover/detail?id=' + id })
        }
      }
    },
    // onRefresh() {
    //   setTimeout(() => {
    //     this.getBasicConfig();
    //     this.isLoading = false;
    //     this.$toast(this.$t('reservation.refresh'));
    //   }, 500);
    // },

    onRefresh() {
      setTimeout(() => {
        this.page = 1
        // this.movielist_1 = []
        this.getNhomeList();
        this.isLoading = false;
        this.$toast(this.$t('reservation.refresh'));
      }, 500);
    },
    onLoad() {
      this.loading = true;
      this.getNhomeList();
      let timer = setTimeout(() => {
        if (this.refreshing) {
          this.movielist_1 = [];
          this.refreshing = false;
        }
        // this.loading = false;
        if (this.movielist_1.length === this.count) {
          this.finished = true;
        }
        this.finished && clearTimeout(timer);//清除计时器
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.basicData = res.data;
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        this.getGameItem();//获取首页游戏列表
        this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1

        this.$nextTick(() => {
          this.lazyLoadImg()
        })
      })

    },
    getNotice(data) {
      this.notice = data.notice || '';
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res => {
        this.gameitem = res.data
      })
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    query(selector) {
      return Array.from(document.querySelectorAll(selector));
    },
    lazyLoadImg() {
      if (this.movielist_1.length > 0) {
        this.query("img[data-src]").forEach((img) => {
          const rect = img.getBoundingClientRect();
          if (rect.top < window.innerHeight) {
            img.src = img.dataset.src;
            // 我们是通过img[data-src]查找所有img标签的，渲染后就删除data-src可减少forEach循环的计算成本
            img.removeAttribute("data-src");
          }
        });
      }
    },

    getNhomeList() {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { page: this.page },
      }).then(res => {
        console.log(res.data, 999)
        this.loading = false;
        if (this.page == 1) {
          this.movielist_1 = res.data;
        } else {

          this.movielist_1 = this.movielist_1.concat(res.data);
        }
        if (res.data.length == 0) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.count = res.data.count;
        this.page++;
      })

    }
  },
  mounted() {
    let that = this;
    window.addEventListener("scroll", () => {
      // 这里做一个 节流 操作
      that.lazyLoadImg()
    });
  },
  created() {
    this.$http({
      method: 'get',
      url: 'base_info'
    }).then(res => {
      if (res.code == 200) {

        if (!localStorage.getItem('token') && res.data.video_login == 1) {
          return this.$router.push({ path: '/auth/login' })
        }
        this.getNhomeList()
        console.log(res)
        this.isLoading = false
        this.isluckdraw = res.data.isluckdraw
        this.pop_content_txt = res.data.pop_content
        this.kefu = res.data.kefu
        this.iskefu = res.data.iskefu
        if (res.data.ispop == 1) {
          this.pop_content = true
        }


        this.$store.commit('setBaseInfoValue', res.data);
        this.getBasicConfig();
      }
    })
  }
}

</script>

<style lang='less' scoped src="./index.styles.less"></style>
